__turbopack_context__.v({
  "parent_link": "VideoThumbnail-module-scss-module__QttteG__parent_link",
  "parent_link_wrapper": "VideoThumbnail-module-scss-module__QttteG__parent_link_wrapper",
  "video_link": "VideoThumbnail-module-scss-module__QttteG__video_link",
  "video_meta": "VideoThumbnail-module-scss-module__QttteG__video_meta",
  "video_thumbnail": "VideoThumbnail-module-scss-module__QttteG__video_thumbnail",
});
